/** Smooth-scroll to a section; the section's scroll-margin-top clears the fixed navbar. */
export function scrollToSection(id: string): void {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  try {
    window.history.replaceState(null, "", `#${id}`);
  } catch {
    /* history can be unavailable in sandboxed frames; the scroll already happened */
  }
}

export function scrollToTop(): void {
  window.scrollTo({ top: 0, behavior: "smooth" });
}
